<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ title }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <p>
      {{ message }}
    </p>
    @if (options.length) {
      @for (option of options; track option.key) {
        <sui-checkbox
          [(ngModel)]="option.value"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ option.label }}
        </sui-checkbox>
      }
    }
    @if (canSchedule || editMode) {
      <app-algorithm-schedule
        [parent]="scheduleForm"
        [initialSchedule]="initialSchedule"
        [editMode]="editMode"
        [initialRecurrence]="initialRecurrence"
        [initialTimezoneId]="initialTimezoneId"
      ></app-algorithm-schedule>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    @if (!hideCancelButton) {
      <sui-button variant="secondary" (click)="cancel()">
        {{ "btn.cancel" | translate }}
      </sui-button>
    }

    @if (!hideConfirmButton) {
      <sui-button
        variant="primary"
        [leadingIcon]="confirmButtonIcon()"
        (click)="confirm()"
      >
        {{ confirmButtonText() }}
      </sui-button>
    }
  </ng-template>
</sui-dialog-simple>
